// App bootstrap (main thread): define routes, restore session, start the router,
// and wire global event-driven UI (toasts + live re-render on world changes).

import $ from 'jquery';
import { api } from './api';
import { defineRoutes, refresh, startRouter } from './router';
import { restore } from './session';
import { toast } from './ui/toast';
import { SignInScreen } from './screens/signin';
import { HomeScreen } from './screens/home';
import { GameDetailScreen } from './screens/gameDetail';
import { NotificationsScreen } from './screens/notifications';
import { ProfileScreen } from './screens/profile';
import { CreateScreen } from './screens/create';
import { ManageScreen } from './screens/manage';
import { FindPlayersScreen } from './screens/find';
import { FriendsScreen } from './screens/friends';
import { AddFriendsScreen } from './screens/addFriends';
import { GroupEditScreen } from './screens/groupEdit';

defineRoutes([
  { pattern: '/signin', screen: SignInScreen, title: 'Giriş', auth: false },
  { pattern: '/home', screen: HomeScreen, title: 'Oyunlar', tab: 'home' },
  { pattern: '/game/:id', screen: GameDetailScreen, title: 'Oyun detayı', back: true },
  { pattern: '/create', screen: CreateScreen, title: 'Oyun oluştur', tab: 'create' },
  { pattern: '/manage/:id', screen: ManageScreen, title: 'Oyunu yönet', back: true },
  { pattern: '/find/:id', screen: FindPlayersScreen, title: 'Oyuncu bul', back: true },
  { pattern: '/friends', screen: FriendsScreen, title: 'Çevrem', tab: 'friends' },
  { pattern: '/add-friends', screen: AddFriendsScreen, title: 'Arkadaş ekle', back: true },
  { pattern: '/group/:id', screen: GroupEditScreen, title: 'Grup', back: true },
  { pattern: '/notifications', screen: NotificationsScreen, title: 'Bildirimler', back: true },
  { pattern: '/profile', screen: ProfileScreen, title: 'Profil', tab: 'profile' },
]);

// Global event wiring: toast on pushed notifications; live refresh on world updates.
// The find-players screen manages its own live DOM updates, so we skip the blunt
// full re-render there to keep its experience smooth.
const onFindScreen = (): boolean => location.hash.startsWith('#/find/');
api.on('notification', (ev) => toast(ev.notification.message, 'info'));
api.on('game-updated', () => {
  if (!onFindScreen()) refresh();
});
api.on('invite-updated', () => {
  if (!onFindScreen()) refresh();
});

async function boot(): Promise<void> {
  await restore();
  startRouter();
}

$(boot);
